import { ptBR } from "date-fns/locale";
import { useContext, useState } from "react";
import DatePicker from "react-datepicker";
import "./styles.css";
import { Button, Table, Input, Label, FormGroup, Row, Col, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import api from "../../../../../../services/axiosConfig";
import { Context } from "../../../../../../hooks/useAuthContext";
import { formatarMoedaDolar } from "../../../../../../utils/formatMoeda";
import { format } from "date-fns";

function TableView() {
  const { exibirLogs } = useContext(Context);
  const [filtro, setFiltro] = useState("contem");
  const [busca, setbusca] = useState("");
  const [tipoContaFiltro, setTipoContaFiltro] = useState("");

  const [relatorios, setRelatorios] = useState([]);
  const [foiBuscado, setFoiBuscado] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dataInicio, setDataInicio] = useState();
  const [dataFim, setDataFim] = useState();
  const [mesCompleto, setMesCompleto] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalResultados, setTotalResultados] = useState(0);
  const [totalReceitaSoma, setTotalReceitaSoma] = useState(0);

  const handleBuscar = async (page = 1) => {
    setLoading(true);
    setFoiBuscado(true);
    setRelatorios([]);

    try {

      const params = {};

      if (dataInicio) {
        params.dataInicio = format(dataInicio, 'dd-MM-yyyy');
      }

      if (dataFim) {
        params.dataFim = format(dataFim, 'dd-MM-yyyy');
      }

      if (busca.trim()) {
        params.termoBusca = busca.trim();
        params.filtro = filtro;
      }

      if (tipoContaFiltro) {
        params.tipoConta = tipoContaFiltro;
      }

      params.page = page;
      params.limit = 1000; 

      const endpoint =
        filtro === "dadosPerdidos"
          ? "/admin/receitas-perdidas"
          : "/admin/receitas";

      const response = await api.get(endpoint, { params });

      const { 
        data, 
        totalItems, 
        totalReceita, 
        totalPages: totalPagesFromApi 
      } = response.data;

      setRelatorios(data  || []);
      setTotalResultados(totalItems || 0);
      setTotalReceitaSoma(totalReceita || 0);
      setTotalPages(totalPagesFromApi || 0);
      setCurrentPage(page);

    } catch (error) {
      exibirLogs && console.log("Erro ao buscar relatórios");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleExportarExcel = async () => {
  setLoading(true); 
  try {
    const params = {};
    if (dataInicio) params.dataInicio = format(dataInicio, 'dd-MM-yyyy');
    if (dataFim) params.dataFim = format(dataFim, 'dd-MM-yyyy');
    if (busca.trim()) {
      params.termoBusca = busca.trim();
      params.filtro = filtro;
    }
    if (tipoContaFiltro) params.tipoConta = tipoContaFiltro;

    const endpoint = filtro === "dadosPerdidos"
      ? "/admin/receitas-perdidas/exportar"
      : "/admin/receitas/exportar";

    const response = await api.get(endpoint, {
      params,
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = `relatorio_receitas_${new Date().toISOString().split('T')[0]}.xlsx`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();

  } catch (error) {
    exibirLogs && console.log("Erro ao exportar relatório do backend");
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const handleMesCompletoCheck = () => {
    const checked = !mesCompleto;
    setMesCompleto(checked);

    if (checked) {
      const now = new Date();
      const primeiroDia = new Date(now.getFullYear(), now.getMonth(), 1);
      const ultimoDia = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      setDataInicio(primeiroDia);
      setDataFim(ultimoDia);
    } else {
      setDataInicio(undefined);
      setDataFim(undefined);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      handleBuscar(newPage);
    }
  };

  return (
    <div className="containerRelatorio">
      
      <FormGroup
        check
        inline
        style={{ alignItems: "center", display: "flex", marginBottom: 20 }}
      >
        <Input
          type="checkbox"
          checked={mesCompleto}
          onChange={handleMesCompletoCheck}
          style={{ marginTop: 2 }}
          valid
        />
        <Label style={{ marginLeft: "5px", marginBottom: 0 }}>
          Mês completo
        </Label>
      </FormGroup>

      <Row>
        <Col md={2} sm={4} xs={4}>
          <FormGroup className="filterGroup">
            <Label for="dataInicio">Data Início:</Label>
            <DatePicker
              selected={dataInicio}
              onChange={(date) => setDataInicio(date)}
              dateFormat="dd/MM/yyyy"
              locale={ptBR}
              className="dateInputRelatorio form-control"
              placeholderText="Data inicial"
              id="dataInicio"
              autoComplete="off"
            />
          </FormGroup>
        </Col>

        <Col md={2} sm={4} xs={4}>
          <FormGroup className="filterGroup">
            <Label for="dataFim">Data Fim:</Label>
            <DatePicker
              selected={dataFim}
              onChange={(date) => setDataFim(date)}
              dateFormat="dd/MM/yyyy"
              locale={ptBR}
              className="dateInputRelatorio form-control"
              placeholderText="Data final"
              id="dataFim"
              autoComplete="off"
            />
          </FormGroup>
        </Col>

        <Col md={2} sm={4} xs={4}>
          <FormGroup className="filterGroup">
            <Label for="filtro">Filtro:</Label>
            <Input
              type="select"
              id="filtro"
              value={filtro}
              onChange={(e) => {
                const novoFiltro = e.target.value;
                setFiltro(novoFiltro);

                if (novoFiltro === "dadosPerdidos") {
                  setbusca("");
                }
              }}
              className="dateInputRelatorio"
            >
              <option value="contem">Contém</option>
              <option value="comecaCom">Começa com</option>
              <option value="dadosPerdidos">Dados perdidos</option>
            </Input>
          </FormGroup>
        </Col>

        <Col md={2}>
          <FormGroup className="filterGroup">
            <Label for="tipoContaFiltro">Tipo de Conta:</Label>
            <Input
              type="select"
              id="tipoContaFiltro"
              value={tipoContaFiltro}
              onChange={(e) => setTipoContaFiltro(e.target.value)}
              className="dateInputRelatorio"
              disabled={filtro === "dadosPerdidos"}
            >
              <option value="">Todos os usuários</option>
              <option value="usuario">Cortadores</option>
              <option value="influenciador">Influenciadores</option>
            </Input>
          </FormGroup>
        </Col>

        <Col md={2} sm={6} xs={8}>
          <FormGroup className="filterGroup">
            <Label for="termo">Buscar (termo):</Label>
            <Input
              type="text"
              id="termo"
              placeholder="push, grupo"
              value={busca}
              onChange={(e) => setbusca(e.target.value)}
              className="dateInputRelatorio"
              disabled={filtro === "dadosPerdidos"}
            />
          </FormGroup>
        </Col>

        <Col md={2} sm={6} xs={4}>
          <FormGroup className="filterGroup">
            <Label>Ação</Label>
            <Button color="primary" block onClick={() => handleBuscar(1)}>
              Buscar
            </Button>
          </FormGroup>
        </Col>
      </Row>

      <div style={{ maxHeight: "400px", overflow: "auto" }}>
        <Row>
          <Col>
            <div>
              {foiBuscado && !loading && relatorios.length > 0 && (
                <Button
                  color="success"
                  block
                  onClick={handleExportarExcel}
                  style={{ fontWeight: "bold" }}
                >
                  Exportar relatório
                </Button>
              )}
            </div>
          </Col>

          <Col
            md={12}
            style={{
              textAlign: "center",
              flexDirection: "column",
              display: "flex",
            }}
          >
            {foiBuscado && !loading && relatorios.length > 0 && (
              <>
                <span
                  style={{
                    marginTop: "10px",
                    fontWeight: "bold",
                    color: "#6d6d6d",
                  }}
                >
                  Total de resultados: {totalResultados}
                </span>
                <strong style={{ fontSize: 20 }}>
                  Total de receita: $ {formatarMoedaDolar(totalReceitaSoma)}
                </strong>
              </>
            )}
          </Col>
        </Row>

        <Table striped>
          <thead>
            <tr>
              <th>utmCampaign</th>
              <th>Receita</th>
              <th>Impressões</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {!foiBuscado ? (
              <tr>
                <td colSpan="4" className="text-center">
                  Nenhuma busca realizada ainda.
                </td>
              </tr>
            ) : loading ? (
              <tr>
                <td colSpan="4" className="text-center">
                  Carregando...
                </td>
              </tr>
            ) : relatorios.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">
                  Nenhum resultado encontrado.
                </td>
              </tr>
            ) : (
              relatorios
                .sort((a, b) => b.impressoes - a.impressoes)
                .map((item) => (
                  <tr key={item._id}>
                    <td>
                      {item.utmCampaign ? item.utmCampaign : item.codeUtm}
                    </td>
                    <td>$ {item.receita?.toFixed(2)}</td>
                    <td>{item.impressoes}</td>
                    <td>{item.data}</td>
                  </tr>
                ))
            )}
          </tbody>
        </Table>
      </div>

      {totalPages > 1 && !loading && (
        <Pagination aria-label="Paginação de resultados" style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 5,
        }}>
          <PaginationItem disabled={currentPage <= 1}>
            <PaginationLink first onClick={() => handlePageChange(1)} />
          </PaginationItem>
          <PaginationItem disabled={currentPage <= 1}>
            <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
          </PaginationItem>
          <PaginationItem active={currentPage}>
            <PaginationLink>
              {currentPage} de {totalPages}
            </PaginationLink>
          </PaginationItem>
          <PaginationItem disabled={currentPage >= totalPages}>
            <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
          </PaginationItem>
          <PaginationItem disabled={currentPage >= totalPages}>
            <PaginationLink last onClick={() => handlePageChange(totalPages)} />
          </PaginationItem>
        </Pagination>
      )}
    </div>
  );
}

export default TableView;
